let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8P3og")).then(() => parcelRequire('95d5o'));